import styled from "styled-components";

export const OrganicMobileComponent = styled.div`
  /* height: 0; */
  height: ${(props) => (props.secHeight ? props.secHeight : 0) + "px"};
  overflow: hidden;
  transition: height 0.5s;
  margin-top: ${(props) => (props.secHeight > 0 ? "-7vh" : 0)};
  position: relative;
  background-color: #00938c;

  /* height: 100%; */
  /* margin-top: 75px; */
  /* padding-top: 5rem; */
  p {
    margin: 0;
  }

  .organic {
    padding-top: calc(5rem + 7vh);
    @media (min-width: 768px) {
      padding-top: 13rem;
    }
  }

  .organicmob__background {
    width: 100%;
    position: absolute;
    @media (min-width: 768px) {
      margin-top: -17rem;
    }
    &--1 {
      top: 0;
    }
    &--2 {
      bottom: 0;
    }
  }
  .organicmob__header {
    position: relative;
    &--text {
      font-size: 2.29878rem;
      text-align: center;
      font-family: coolvetica_rg;
      line-height: 0.92;
      color: #11112f;
      @media (min-width: 768px) {
        font-size: 3.06504rem;
      }
    }
    &--img {
      width: 45%;
      position: absolute;
      left: 0;
      right: 0;
      top: -4rem;
      margin: auto;
      @media (min-width: 768px) {
        width: 25%;
        top: -5rem;
      }
    }
  }
  .organicmob__person {
    width: 90%;
    display: block;
    position: relative;
    z-index: 1;
    margin: auto;
    margin-top: -18px;
    top: 2px;
    @media (min-width: 768px) {
      width: 60%;
    }
    @media (min-width: 500px) {
      top: 5px;
    }
  }
  .organicmob__person--hidden {
    visibility: hidden;
  }
  .organicmob__person--visible {
    position: absolute;
    top: unset;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .organicmob__ball {
    margin-top: -63px;
    position: relative;
    @media (min-width: 768px) {
      margin-top: -87px;
    }
    &--background {
      width: 100%;
      @media (min-width: 768px) {
        height: 90px;
      }
    }
    &--img {
      width: 20%;
      position: absolute;
      top: 10px;
      left: 0;
      right: 0;
      margin: auto;
      z-index: 2;
      @media (min-width: 768px) {
        width: 10%;
        top: 30px;
      }
    }
  }
  .organicmob__demonstrate {
    background-color: #fff;
    margin-top: -5px;
    padding-top: 3rem;
    padding-bottom: 1rem;
    position: relative;
    z-index: 1;
    &--header {
      font-family: poppinsBold;
      font-size: 1.125rem;
      text-align: center;
      margin-bottom: 5px;
      color: #11112f;
      @media (min-width: 768px) {
        font-size: 1.5rem;
      }
    }
    &--content {
      font-family: poppinsRegular;
      font-size: 0.8125rem;
      width: 85%;
      margin: auto;
      text-align: justify;
      color: #3c3c3b;
      @media (min-width: 768px) {
        font-size: 1.333333333333333rem;
      }
      span {
        font-family: poppinsBold;
      }
      &-blue {
        color: #11112f;
      }
    }
  }
  .organicmob__flag {
    margin-top: 0;
    z-index: 1;
    &--img {
      top: 4px;
    }
  }
  .organicmob__insightful {
    z-index: 0;
    background-color: transparent;
    color: #fff;
    padding-top: 2.5rem;
    &--content {
      color: #fff;
      margin-top: 0.5rem;
    }
    &--excalibur {
      width: 100%;
      max-width: 60vw;
      display: block;
      margin: 0.5rem auto;

      @media (min-width: 768px) {
        width: 55%;
        margin: auto;
        display: block;
      }
    }
  }
`;
